module.exports = __webpack_public_path__ + "media/images/sp/special_reports/main-visual-72cce53c75744a463bc4187c6b9a29a1.jpg";